import React from "react";

type ConfirmationModalProps = {
  show: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel?: string;
  confirmColor?: "yellow" | "green" | "red" | "slate";
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
};

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  title,
  message,
  confirmLabel,
  cancelLabel = "Cancel",
  confirmColor = "green",
  onConfirm,
  onCancel,
  loading = false,
}) => {
  if (!show) return null;

  const confirmColorClasses = {
    yellow: "bg-amber-500 hover:bg-amber-600",
    green:  "gradient-bg hover:opacity-90",
    red:    "bg-red-500 hover:bg-red-600",
    slate:  "bg-slate-500 hover:bg-slate-600",
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-md">
        <h3 className="text-lg font-semibold text-gray-800 mb-3">{title}</h3>
        <p className="text-gray-600 text-sm mb-6">{message}</p>
        <div className="flex justify-end space-x-3">
          <button
            className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition text-sm"
            onClick={onCancel}
            disabled={loading}
          >
            {cancelLabel}
          </button>
          <button
            className={`px-4 py-2 rounded-lg text-white transition text-sm font-medium ${confirmColorClasses[confirmColor]}`}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Processing..." : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
